import { html, TemplateResult, LitElement} from 'lit';
import { customElement} from 'lit/decorators.js';
import globalStyles from './outline-alert.global.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-alert';

/**
 * The Outline Core Alert component
 *
 * A reusable LitElement component for displaying alert.
 * This is a wrapper element for content generated by the
 * Sitewide Alert module.
 *
 * @element outline-alert
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineAlert extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineAlert;
  }
}
